import { t } from '@lingui/macro';
import { Device } from '@/__generated__/graphql';

export const getSectionFields = () => ({
  general: {
    inputs: [
      {
        name: 'hardwareConfiguration.googleDriveUrl',
        label: t`URL Google Drive`,
      },
      {
        name: 'profile.project',
        label: t`Nombre del proyecto`,
      },
      {
        name: 'hardwareConfiguration.lockNumber',
        label: t`Número de chapa`,
      },
      {
        name: 'profile.dateAction',
        label: t`Fecha de activación`,
      },
      {
        name: 'hardwareConfiguration.account.email',
        label: t`Cuenta usuario`,
      },
      {
        name: 'hardwareConfiguration.account.name',
        label: t`Nombre usuario`,
      },
      {
        name: 'hardwareConfiguration.observation',
        label: t`Observación`,
      },
      {
        name: 'hardwareConfiguration.configurationFile.name',
        label: t`Archivo de configuración`,
      },
    ],
    label: t`General`,
  },
  sensorization: {
    inputs: [],
    label: t`Sensorización`,
  },
  energization: {
    inputs: [
      {
        name: 'hardwareConfiguration.energizationOption.name',
        label: t`Energización`,
      },
      {
        name: 'hardwareConfiguration.solarControllerModelOption.name',
        label: t`Paneles solares`,
        displayed: (device: Device) => {
          const energizationName = device?.hardwareConfiguration?.energizationOption?.name;
          return energizationName === 'Red 220VAC y Solar' || energizationName === 'Solar';
        },
      },
      {
        name: 'hardwareConfiguration.numberSolarPanelsControllers',
        label: t`Número de serie controlador solar`,
        displayed: (device: Device) => {
          const energizationName = device?.hardwareConfiguration?.energizationOption?.name;
          return energizationName === 'Red 220VAC y Solar' || energizationName === 'Solar';
        },
      },
      {
        name: 'hardwareConfiguration.batteryCapacityOption.name',
        label: t`Batería`,
        displayed: (device: Device) => {
          const energizationName = device?.hardwareConfiguration?.energizationOption?.name;
          return (
            energizationName === 'Solar' ||
            energizationName === 'Red 220VAC y Solar' ||
            energizationName === 'Red 220VAC (UPS)'
          );
        },
      },
      {
        name: 'hardwareConfiguration.quantityBattery',
        label: t`Cantidad de baterías`,
        displayed: (device: Device) => {
          const energizationName = device?.hardwareConfiguration?.energizationOption?.name;
          return (
            energizationName === 'Solar' ||
            energizationName === 'Red 220VAC y Solar' ||
            energizationName === 'Red 220VAC (UPS)'
          );
        },
      },
      {
        name: 'hardwareConfiguration.modelBattery',
        label: t`Modelo de batería`,
        displayed: (device: Device) => {
          const energizationName = device?.hardwareConfiguration?.energizationOption?.name;
          return (
            energizationName === 'Solar' ||
            energizationName === 'Red 220VAC y Solar' ||
            energizationName === 'Red 220VAC (UPS)'
          );
        },
      },
      {
        name: 'hardwareConfiguration.technologyOption.name',
        label: t`Tecnología`,
        displayed: (device: Device) => {
          const energizationName = device?.hardwareConfiguration?.energizationOption?.name;
          return (
            energizationName === 'Solar' ||
            energizationName === 'Red 220VAC y Solar' ||
            energizationName === 'Red 220VAC (UPS)'
          );
        },
      },
      {
        name: 'hardwareConfiguration.batteryVoltageOption.name',
        label: t`Voltaje`,
        displayed: (device: Device) => {
          const energizationName = device?.hardwareConfiguration?.energizationOption?.name;
          return (
            energizationName === 'Solar' ||
            energizationName === 'Red 220VAC y Solar' ||
            energizationName === 'Red 220VAC (UPS)'
          );
        },
      },
      {
        name: 'hardwareConfiguration.quantitySun',
        label: t`Cantidad de paneles solares`,
        displayed: (device: Device) => {
          const energizationName = device?.hardwareConfiguration?.energizationOption?.name;
          return energizationName === 'Red 220VAC y Solar' || energizationName === 'Solar';
        },
      },
      {
        name: 'hardwareConfiguration.modelsSun',
        label: t`Modelo de paneles solares`,
        displayed: (device: Device) => {
          const energizationName = device?.hardwareConfiguration?.energizationOption?.name;
          return energizationName === 'Red 220VAC y Solar' || energizationName === 'Solar';
        },
      },
      {
        name: 'hardwareConfiguration.watts',
        label: t`Watts`,
        displayed: (device: Device) => {
          const energizationName = device?.hardwareConfiguration?.energizationOption?.name;
          return energizationName === 'Red 220VAC y Solar' || energizationName === 'Solar';
        },
      },
      {
        name: 'hardwareConfiguration.numberSun',
        label: t`Número de serie`,
        displayed: (device: Device) => {
          const energizationName = device?.hardwareConfiguration?.energizationOption?.name;
          return energizationName === 'Red 220VAC y Solar' || energizationName === 'Solar';
        },
      },
      {
        name: 'hardwareConfiguration.powerSupplyVoltageOption.name',
        label: t`Voltaje fuente DC`,
        displayed: (device: Device) => {
          const energizationName = device?.hardwareConfiguration?.energizationOption?.name;
          return energizationName !== 'Solar';
        },
      },
      {
        name: 'hardwareConfiguration.powerSupplyModel',
        label: t`Modelo fuente DC`,
        displayed: (device: Device) => {
          const energizationName = device?.hardwareConfiguration?.energizationOption?.name;
          return energizationName !== 'Solar';
        },
      },
      {
        name: 'hardwareConfiguration.powerSupplySerialNumber',
        label: t`Número de serie fuente DC`,
        displayed: (device: Device) => {
          const energizationName = device?.hardwareConfiguration?.energizationOption?.name;
          return energizationName !== 'Solar';
        },
      },
      {
        name: 'hardwareConfiguration.powerSupplyBrand',
        label: t`Marca fuente DC`,
        displayed: (device: Device) => {
          const energizationName = device?.hardwareConfiguration?.energizationOption?.name;
          return energizationName !== 'Solar';
        },
      },
    ],
    label: t`Energización`,
  },
  processor: {
    inputs: [
      {
        name: 'hardwareConfiguration.cpuOption.name',
        label: t`CPU`,
      },
      {
        name: 'hardwareConfiguration.batchNumberCpu',
        label: t`Número de lote CPU`,
      },
      {
        name: 'hardwareConfiguration.serialNumberWidgetlord',
        label: t`Número de serie Widgetlord`,
      },
      {
        name: 'hardwareConfiguration.batchNumberWidgetlord',
        label: t`Número de lote Widgetlord`,
      },
      {
        name: 'hardwareConfiguration.codeNumberWidgetlord',
        label: t`Código Widgetlord`,
      },
      {
        name: 'hardwareConfiguration.auxiliaryOption.name',
        label: t`Placa auxiliar`,
      },
      {
        name: 'hardwareConfiguration.numberAuxiliary',
        label: t`Número de serie`,
      },
      {
        name: 'hardwareConfiguration.batchNumberAuxiliary',
        label: t`Número de lote placa auxiliar`,
      },
      {
        name: 'hardwareConfiguration.imageVersion',
        label: t`Versión de imagen`,
      },
      {
        name: 'hardwareConfiguration.usbExtraction',
        label: t`Extracción USB`,
      },
    ],
    label: t`Data logger`,
  },
  connectivity: {
    inputs: [
      {
        name: 'hardwareConfiguration.internetConnectionOption.name',
        label: t`Conexión a internet`,
      },
      {
        name: 'hardwareConfiguration.modelsConnectionOption.name',
        label: t`Modelo de conexión`,
        displayed: (device: Device) => {
          const internetConnectionName =
            device?.hardwareConfiguration?.internetConnectionOption?.name;
          return internetConnectionName === 'Redes Móviles';
        },
      },
      {
        name: 'hardwareConfiguration.imei',
        label: t`IMEI`,
        displayed: (device: Device) => {
          const internetConnectionName =
            device?.hardwareConfiguration?.internetConnectionOption?.name;
          return (
            internetConnectionName === 'Redes Móviles' ||
            internetConnectionName === 'Internet Satelital'
          );
        },
      },
      {
        name: 'hardwareConfiguration.batchNumberSimCard',
        label: t`Número de lote SIM Card`,
        displayed: (device: Device) => {
          const internetConnectionName =
            device?.hardwareConfiguration?.internetConnectionOption?.name;
          return internetConnectionName === 'Redes Móviles';
        },
      },
      {
        name: 'hardwareConfiguration.approved',
        label: t`Homologado`,
        displayed: (device: Device) => {
          const internetConnectionName =
            device?.hardwareConfiguration?.internetConnectionOption?.name;
          return internetConnectionName === 'Redes Móviles';
        },
      },
      {
        name: 'hardwareConfiguration.mobileOperatorOption.name',
        label: t`Operador móvil`,
        displayed: (device: Device) => {
          const internetConnectionName =
            device?.hardwareConfiguration?.internetConnectionOption?.name;
          return internetConnectionName === 'Redes Móviles';
        },
      },
      {
        name: 'hardwareConfiguration.phoneNumber',
        label: t`Número de teléfono`,
        displayed: (device: Device) => {
          const internetConnectionName =
            device?.hardwareConfiguration?.internetConnectionOption?.name;
          const mobileOperatorName = device?.hardwareConfiguration?.mobileOperatorOption?.name;
          return (
            internetConnectionName === 'Redes Móviles' &&
            mobileOperatorName !== 'Emnify' &&
            mobileOperatorName !== 'Mint'
          );
        },
      },
      {
        name: 'hardwareConfiguration.dataPlanMobileOption.name',
        label: t`Plan de datos`,
        displayed: (device: Device) => {
          const internetConnectionName =
            device?.hardwareConfiguration?.internetConnectionOption?.name;
          const mobileOperatorName = device?.hardwareConfiguration?.mobileOperatorOption?.name;
          return (
            internetConnectionName === 'Redes Móviles' &&
            mobileOperatorName !== 'Emnify' &&
            mobileOperatorName !== 'Mint'
          );
        },
      },
      {
        name: 'hardwareConfiguration.idEmnify',
        label: t`ID Emnify`,
        displayed: (device: Device) => {
          const internetConnectionName =
            device?.hardwareConfiguration?.internetConnectionOption?.name;
          const mobileOperatorName = device?.hardwareConfiguration?.mobileOperatorOption?.name;
          return internetConnectionName === 'Redes Móviles' && mobileOperatorName === 'Emnify';
        },
      },
      {
        name: 'hardwareConfiguration.antennaOption.name',
        label: t`Antena`,
        displayed: (device: Device) => {
          const internetConnectionName =
            device?.hardwareConfiguration?.internetConnectionOption?.name;
          return internetConnectionName === 'Redes Móviles';
        },
      },
      {
        name: 'hardwareConfiguration.iccid',
        label: t`ICCID`,
        displayed: (device: Device) => {
          const internetConnectionName =
            device?.hardwareConfiguration?.internetConnectionOption?.name;
          return (
            internetConnectionName === 'Redes Móviles' ||
            internetConnectionName === 'Internet Satelital'
          );
        },
      },
      {
        name: 'hardwareConfiguration.ip',
        label: t`IP`,
        displayed: (device: Device) => {
          const internetConnectionName =
            device?.hardwareConfiguration?.internetConnectionOption?.name;
          const mobileOperatorName = device?.hardwareConfiguration?.mobileOperatorOption?.name;
          return internetConnectionName === 'Redes Móviles' && mobileOperatorName === 'Emnify';
        },
      },
      {
        name: 'hardwareConfiguration.mac',
        label: t`MAC`,
        displayed: (device: Device) => {
          const internetConnectionName =
            device?.hardwareConfiguration?.internetConnectionOption?.name;
          return (
            internetConnectionName === 'Red Cableada' ||
            internetConnectionName === 'Red Inalámbrica'
          );
        },
      },
      {
        name: 'hardwareConfiguration.configurationIp',
        label: t`Configuración IP`,
        displayed: (device: Device) => {
          const internetConnectionName =
            device?.hardwareConfiguration?.internetConnectionOption?.name;
          return (
            internetConnectionName === 'Red Cableada' ||
            internetConnectionName === 'Red Inalámbrica'
          );
        },
      },
      {
        name: 'hardwareConfiguration.administrator',
        label: t`Administrador`,
        displayed: (device: Device) => {
          const internetConnectionName =
            device?.hardwareConfiguration?.internetConnectionOption?.name;
          return (
            internetConnectionName === 'Red Cableada' ||
            internetConnectionName === 'Red Inalámbrica'
          );
        },
      },
      {
        name: 'hardwareConfiguration.networkName',
        label: t`Nombre de red`,
        displayed: (device: Device) => {
          const internetConnectionName =
            device?.hardwareConfiguration?.internetConnectionOption?.name;
          return internetConnectionName === 'Red Inalámbrica';
        },
      },
      {
        name: 'hardwareConfiguration.satellitalTypeOption.name',
        label: t`Tipo satelital`,
        displayed: (device: Device) => {
          const internetConnectionName =
            device?.hardwareConfiguration?.internetConnectionOption?.name;
          return internetConnectionName === 'Internet Satelital';
        },
      },
      {
        name: 'hardwareConfiguration.satellitalSerialName',
        label: t`Número Serial del Hardware`,
        displayed: (device: Device) => {
          const internetConnectionName =
            device?.hardwareConfiguration?.internetConnectionOption?.name;
          return internetConnectionName === 'Internet Satelital';
        },
      },
      {
        name: 'hardwareConfiguration.satellitalHardwareName',
        label: t`Nombre del Hardware`,
        displayed: (device: Device) => {
          const internetConnectionName =
            device?.hardwareConfiguration?.internetConnectionOption?.name;
          return internetConnectionName === 'Internet Satelital';
        },
      },
      {
        name: 'hardwareConfiguration.satellitalHv',
        label: t`Versión del Hardware`,
        displayed: (device: Device) => {
          const internetConnectionName =
            device?.hardwareConfiguration?.internetConnectionOption?.name;
          const satellitalTypeName = device?.hardwareConfiguration?.satellitalTypeOption?.name;
          return (
            internetConnectionName === 'Internet Satelital' && satellitalTypeName === 'Rock Remote'
          );
        },
      },
      {
        name: 'hardwareConfiguration.satellitalSv',
        label: t`Versión del Software`,
        displayed: (device: Device) => {
          const internetConnectionName =
            device?.hardwareConfiguration?.internetConnectionOption?.name;
          const satellitalTypeName = device?.hardwareConfiguration?.satellitalTypeOption?.name;
          return (
            internetConnectionName === 'Internet Satelital' && satellitalTypeName === 'Rock Remote'
          );
        },
      },
    ],
    label: t`Conectividad`,
  },
});
